import { useIsHeidi2OptInEnabled } from '@/app-shell/flags/agents-flags';
import { IS_TEAM_EVIDENCE_ACCESS_CONTROLS_ENABLED } from '@/app-shell/flags/evidence-flags';
import { useSettingsModal } from '@/app-shell/settings/hooks/useSettingsModal';
import { useDeeplinkAction } from '@/hooks/useDeeplinkAction';
import {
  activateClinicianTrial,
  activateHeidi2ClinicianTrial,
} from '@heidi/commerce/data';
import { toast, ToastActionButton } from '@heidi/design-system/toast';
import { useCombinedQueriesTeamGeneralInfo } from '@heidi/workspace/data';
import { useIntl } from 'react-intl';
import { useMutateActivateTrial } from './useMutateActivateTrial';

export function useMutateActivateClinicianTrial() {
  const deeplinkAction = useDeeplinkAction();
  const intl = useIntl();
  const { open: openSettingsModal } = useSettingsModal();
  const { isTeamAdmin } = useCombinedQueriesTeamGeneralInfo();
  const isHeidi2OptInEnabled = useIsHeidi2OptInEnabled();

  return useMutateActivateTrial({
    mutationKey: 'activateClinicianTrial',
    activate: isHeidi2OptInEnabled
      ? activateHeidi2ClinicianTrial
      : activateClinicianTrial,
    errorTitle: {
      defaultMessage: 'Failed to activate clinician trial',
      id: 'hZRRGtZk4K',
    },
    refreshLogContext: 'clinician trial activation',
    afterSuccess: () => {
      if (
        deeplinkAction !== 'activate-evidence' ||
        !isTeamAdmin ||
        isHeidi2OptInEnabled
      ) {
        return;
      }

      const manageAccessLabel = intl.formatMessage({
        defaultMessage: 'Manage access',
        id: 'HLn43Rj0b/',
      });
      toast({
        tone: 'success',
        title: intl.formatMessage({
          defaultMessage: 'Your team now has access to Evidence',
          id: 'Ze0C3moPJy',
        }),
        ...(IS_TEAM_EVIDENCE_ACCESS_CONTROLS_ENABLED()
          ? {
              action: (
                <ToastActionButton
                  tone="success"
                  onClick={() => {
                    openSettingsModal(
                      '/settings/team#access',
                      'evidence_trial_activated_toast'
                    );
                  }}
                >
                  {manageAccessLabel}
                </ToastActionButton>
              ),
            }
          : {}),
      });
    },
  });
}
